<template>
  <div>
    <!-- 4个引导页 分别对应 4个currentLayer -->
    <!-- v-if="showLayer" -->
    <div v-if="showLayer" class="layer">
      <!-- 每个layer对应上下左右4个区块 -->
      <div v-if="currentLayer === 1">
        <div class="layer1">
          <div class="layer1-title">{{ $t('Sop.QuickEntryLayer.FirstLine') }}</div>
          <div class="layer-arrow-top">
            <svg-icon icon-class="guide-arrow" class="arrow-common" />
          </div>
        </div>
        <div class="layer2">
          <div class="layer-title-bottom">
            {{ $t('Sop.QuickEntryLayer.SecondLine') }}
          </div>
          <div class="layer-arrow-bottom">
            <svg-icon icon-class="guide-arrow" class="arrow-common" />
          </div>
        </div>
        <div class="layer3" :style="{width: isOpen? '207px': '50px'}" />
        <div class="layer4" />
      </div>
      <div v-if="currentLayer === 2">
        <div class="second-layer1" />
        <div class="second-layer2">
          <div class="second-arrow">
            <svg-icon icon-class="guide-arrow" class="arrow-common" />
          </div>
          <div class="second-tip">
            <div>{{ $t('Sop.SopBoardLayer.FirstLine2') }}</div>
            <div>{{ $t('Sop.SopBoardLayer.SecondLine2') }}</div>
            <!--            <div>{{ $t('Sop.SopBoardLayer.ThirdLine') }}</div>-->
          </div>
        </div>
        <div class="second-layer3" :style="{width: isOpen? '207px': '50px'}" />
        <div class="second-layer4" />
      </div>
      <div v-if="currentLayer === 3">
        <div class="three-layer1">
          <div class="three-tip">
            <div>{{ $t('Sop.LineChartLayer.FirstLine') }}</div>
            <!-- 曲线图隐藏文案 -->
            <!-- <div>{{ $t('Sop.LineChartLayer.SecondLine') }}</div> -->
            <div class="three-arrow">
              <svg-icon icon-class="guide-arrow" class="arrow-common" />
            </div>
          </div>

        </div>
        <div class="three-layer2" />
        <div class="three-layer3" :style="{width: isOpen? '207px': '50px'}" />
        <div class="three-layer4" />
      </div>
      <!--      <div v-if="currentLayer === 4">-->
      <!--        <div class="four-layer1" />-->
      <!--        <div class="four-layer2">-->
      <!--          <div class="four-tip">{{ $t('Sop.SettingLayer.FirstLine') }}</div>-->
      <!--          <div class="four-arrow">-->
      <!--            <svg-icon icon-class="guide-arrow-setting" class="arrow-common-four" />-->
      <!--          </div>-->
      <!--          <div class="four-tip1">{{ $t('Sop.SettingLayer.SecondLine') }}</div>-->
      <!--          <div class="four-arrow">-->
      <!--            <svg-icon icon-class="guide-arrow-setting" class="arrow-common-four1" />-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="four-layer3" :style="`right:${layerRight2}px`" />-->
      <!--        <div class="four-layer4" :style="`width: ${layerWidth}px`" />-->
      <!--        <div class="four-layer5" :style="`right: ${layerRight}px`" />-->
      <!--      </div>-->
      <div>
        <div class="next-step" @click="nextStep">{{ $t('Sop.NextStep') }}</div>
        <div class="circle-wrapper">
          <span :class="{active: currentLayer === 1}" @click="showCurrentLayer(1)" />
          <span :class="{active: currentLayer === 2}" @click="showCurrentLayer(2)" />
          <span :class="{active: currentLayer === 3}" @click="showCurrentLayer(3)" />
          <!--          <span :class="{active: currentLayer === 4}" @click="showCurrentLayer(4)" />-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    showLayer: {
      type: Boolean,
      default: true
    },
    scrollbarWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentLayer: 1
    }
  },
  computed: {
    ...mapGetters(['userId', 'sidebar']),
    isOpen() {
      return this.sidebar.opened
    },
    showLayer_: {
      get() {
        return this.showLayer
      },
      set(val) {
        this.$emit('handleColseMask', val)
      }
    },
    layerRight() {
      if (this.scrollbarWidth > 0) {
        return this.scrollbarWidth + 36
      } else {
        return 36
      }
    },
    layerWidth() {
      if (this.scrollbarWidth > 0) {
        return this.scrollbarWidth + 9
      } else {
        return 9
      }
    },
    layerRight2() {
      if (this.scrollbarWidth > 0) {
        return this.scrollbarWidth + 180
      } else {
        return 180
      }
    }
  },
  methods: {
    nextStep() {
      this.currentLayer = this.currentLayer + 1
      if (this.currentLayer > 3) {
        // 蒙层引导关闭时 除非清楚浏览器缓存否则不弹出
        this.$emit('handleColseMask')
        localStorage.setItem(`sopGuide${this.userId}`, false)
      }
    },
    showCurrentLayer(currentLayer) {
      this.currentLayer = currentLayer
    }
  }
}
</script>
<style lang="scss">
  .layer {
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    font-size: 14px;
    // background-color: rgba($color: #000000, $alpha: .3);
    z-index: 1002;
    .isCollapse {
      width: 50px !important;
    }
    .arrow-common {
      width: 124px;
      height: 67px;
    }
    .arrow-common-four {
      width: 85px;
      height: 115px;
    position: absolute;
    right: -26px;
    top: 12px;
    }
    .arrow-common-four1 {
          width: 85px;
      height: 115px;
    position: absolute;
    right: 112px;
    top: 3px;

    }
    .layer1{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 158px;
      background-color: rgba(0, 0, 0, 0.5);
      .layer-arrow-top {
        position: absolute;
        top: 95px;
        left: 353px;
        transform: rotate(180deg);
      }
      .layer1-title {
          position: absolute;
          top:95px;
          left: 475px;
          width:141px;
        }
    }
    .layer2{
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 265px;
      .layer-title-bottom {
        position: absolute;
        left: 297px;
        top: 17px;
      }
      .layer-arrow-bottom{
        position: absolute;
        left:191px;
        top: 3px;
      }
    }
    .layer3 {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      width:207px;
      height: 107px;
      top: 158px;
    }
    .layer4 {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      width: 13px;
      right:0;
      height: 107px;
      top:158px;
    }
    .second-layer1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 281px;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .second-layer2 {
      position: absolute;
      top: 579px;
      left: 0;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      height: 100%;
      .second-tip {
        position: absolute;
        left: 706px;
        line-height: 24px;
      }
      .second-arrow{
        position: absolute;
        left: 1000px;
        // transform: rotate(180deg);
      }
    }
    .second-layer3 {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      width:207px;
      height: 300px;
      top: 281px;
    }
    .second-layer4 {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      width: 13px;
      right:0;
      height: 300px;
      top:281px;
    }
    .three-layer1 {
      position: absolute;
      width: 100%;
      height: 592px;
      background-color: rgba(0, 0, 0, 0.5);
      .three-tip {
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        line-height: 24px;
        .three-arrow {
          position: absolute;
        top: -5px;
        left: -128px;
        transform: rotate(180deg);
      }
    }
    }
    .three-layer2 {
      position: absolute;
      width: 100%;
      top: 1042px;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .three-layer3 {
      position: absolute;
      width: 207px;
      top: 592px;
      height: 450px;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .three-layer4 {
      position: absolute;
      width: 13px;
      top: 592px;
      height: 450px;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .four-layer1 {
      position: absolute;
      width: 100%;
      height: 83px;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .four-layer2 {
      position: absolute;
      width:100%;
      background-color: rgba(0, 0, 0, 0.5);
      top: 110px;
      height: 100%;
      .four-tip {
        position: absolute;
        top: 86px;
        right: 25px;
        width: 110px;
        line-height: 16px;
      }
      .four-tip1 {
        position: absolute;
        top: 72px;
        right: 166px;
        line-height: 16px;
      }
      .four-arrow {
        position: absolute;
        top: -25px;
        right: 40px;
        z-index: 10;
      }
    }
    .four-layer3 {
      position: absolute;
      right: 36px;
      left: 0px;
      background-color: rgba(0, 0, 0, 0.5);
      top: 83px;
      height: 27px;
    }
    .four-layer4 {
      position: absolute;
      right: 0;
      width: 9px;
      background-color: rgba(0, 0, 0, 0.5);
      top: 83px;
      height: 27px;
    }
    .four-layer5 {
      width: 10px;
      position: absolute;
      top: 83px;
      background: rgba(0, 0, 0, 0.5);
      height: 27px;
    }
    .next-step {
      position: absolute;
      top: 55px;
      left: 50%;
      transform: translate(-50%);
      padding: 0 20px;
      height: 28px;
      border: 1px solid #fff;
      line-height: 28px;
      text-align: center;
      border-radius: 2px;
      color:#fff;
      cursor: pointer;
      // background-color: rgba(0, 0, 0, 0.5);
    }
    .circle-wrapper {
      position: absolute;
      top: 98px;
      left: 50%;
      transform: translateX(-50%);
      // background-color: rgba(0, 0, 0, 0.5);
      span {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #fff;
        opacity: .34;
        margin-right: 5px;
        cursor: pointer;
      }
      span.active {
        opacity: 1;
      }
    }
    .entry {
      position: absolute;
      top: 160px;
      left: 213px;
      width: 100%;
      height: 146px;
      border: 1px solid #fff;
    }
  }
</style>
